module.exports = __webpack_public_path__ + "staticcomp/img/cover.7bf7cfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/11/cover.jpg
// module id = 0ZaJ
// module chunks = 39